import React, { useEffect, useState } from "react";
import "./searching.css";
import { FilterOutlined ,CloseCircleOutlined } from "@ant-design/icons";
import {  useMutation } from "react-query";
import {productsApi } from "./api";
import {Typography,Space,Card,Button,Tree,Input,Pagination,Empty,Modal,Spin,} from "antd";
import { Link } from "react-router-dom";

const Searching = ({ setId, product_id }) => {
  const { Text, Title } = Typography;
  const { Search } = Input;
  // Api data
  const [products, setProducts] = useState([]);
  const [user]= useState(JSON.parse(window.localStorage.getItem("loggedUser")))
  // searchingKeyword states
  const [searchingKeyword, setSearch] = useState("");
  const [isSearched, setisSearched]= useState(false);
  const [filteration, setFilteration]= useState({})
  // pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [offset, setOffset] = useState(0)
  const [skip,setSkip] = useState(0)
    //   handle Pagination
    const handlePage = (pageNumber) => {
      setCurrentPage(pageNumber);
      setOffset((pageNumber-1) * postsPerPage)
    };
  
  let newData = products?.slice(
    (currentPage - 1) * postsPerPage,
    postsPerPage * currentPage
  );
  // popup
  const [isModalVisible, setIsModalVisible] = useState(false);
  // dropdown tree states
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  //   handle tree's categories functions
  const onExpand = (expandedKeys, info) => {
   // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };
  const onCheck = (checkedKeys, info) => {
    setCheckedKeys(checkedKeys);
    let parent = info.node.parent;
    setFilteration((prev) => {
        let keys = { ...prev };
        keys[parent] = info.checkedNodes.filter((item) => item.parent === parent).map((item) => item.value);
        return keys;
    });
  };
  const onSelect = (selectedKeys, info) => {
    setSelectedKeys(selectedKeys);
  };
  // popup functions
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  //   categories tree data1
  const treeData = [
    {
      title: "Shelf Life",
      key: "0",
      checkable: false,
      
      children: [
        {
          title: "10",
          key: "0-1",
          value:"10",
          parent:"shelfLife",
          checkable: true,
          
        },
        {
          title: "20",
          key: "0-2",
          value:"20",
          parent:"shelfLife",
          checkable: true,
        },
        
      ],
    },
    {
      title: "Trade Name",
      key: "1",
      checkable: false,
      children: [
        {
          title: "Head & Shoulder",
          value:"Head & Shoulder",
          parent:"tradeName",
          key: "1-1",
        },
      ],
    },
  ];
  //   handle search change
  const handleChange = (value) => {
    setSearch(value);
  }
      
      const handleSearchAndFilteration = ()=>{
        let filterationObj ={}
        let searchObj = {};
        if ((Object.keys(filteration).length>0) ||(searchingKeyword) ){
          for (let key in filteration){
            let newKey = key;
            filterationObj[newKey]=filteration[key].toString();
          }
          
          if(searchingKeyword){
            setisSearched(true)
          }
          setIsModalVisible(false)
          mutation({user:user.jwtToken, skip, searchingKeyword, filteration:filterationObj })
        }
  }
    const handleCloseButton = ()=>{
      let filterationObj ={}
      if (Object.keys(filteration).length>0){
        for (let key in filteration){
          let newKey = key;
          filterationObj[newKey]=filteration[key].toString();
        }
      }
      setSearch("")
        mutation({ user:user.jwtToken,skip:0, searchingKeyword:"", filteration:filterationObj});
      setisSearched(false);
    }
 const handleId = (e) => {
    setId(e.currentTarget.id);
  };

  // Api calls
  useEffect(()=>{
    mutation({ user:user.jwtToken,skip, searchingKeyword, filteration})
  },[])
useEffect(()=>{
  setTimeout(()=>{
    if ((offset >= products.length-10) && (offset > 0) && (Object.keys(filteration).length==0) && (searchingKeyword=="")) {
        mutation({ user:user.jwtToken,skip, searchingKeyword, filteration })
      }
    },0)
  },[currentPage])
  const {mutate:mutation, isLoading}= useMutation((data)=>{
    return productsApi.getProductsPage(data?.user, data?.skip, data?.searchingKeyword, data?.filteration)
  },{
    onSuccess:(data)=>{
      if (!(data?.data?.data)) {
        console.log("not data");  
        return;
      }
      if((searchingKeyword.length > 0 && data?.data?.data) || (Object.keys(filteration).length) ){
        setSkip((data?.data?.data).length)
        setProducts(data?.data?.data);
        
      }
      else{
        setSkip(products.concat(data?.data?.data).length)
        setProducts(products.concat(data?.data?.data))
      }
    }
  })
  return (
    <div>
      {product_id ? null : (
        <div style={{ width: "90%" }}>
          <div className="banner">
            <Text>
              <Title level={3} className="search_title">
                Search Products
              </Title>
            </Text>
            <Text>
              <Title level={5}>
                Find numerous unregistered products that can fulfill you need
              </Title>
            </Text>
          </div>
          <div className="main_container">
            {/* for searchingKeyword */}
            <div>
              <Button
                type="default"
                size="large"
                onClick={showModal}
                className="filteration"
              >
                <FilterOutlined /> Filters
              </Button>
            </div>
            <div>
              <Search
                enterButton="Search"
                size="large"
                placeholder="Search Product"
                className="search_bar"
                onSearch={handleSearchAndFilteration}
                value={searchingKeyword}
                onChange={(e) => handleChange(e.target.value)}
              />
            </div>
            <Modal
              title="Filters"
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={[
                <Button key="1" onClick={()=>setCheckedKeys([])}>Reset</Button>,
                <Button key="2" type="primary" onClick={handleSearchAndFilteration}>
                  Apply
                </Button>,
              ]}
            >
              <Tree
                checkable
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                onSelect={onSelect}
                selectedKeys={selectedKeys}
                treeData={treeData}
              />
            </Modal>
          </div>

          {/* for showing result */}
          <div className={isSearched?"showing_result":"showing_filter_result"}>
            {isSearched ?(

              <div className="filter_search">
              <Text>Showing results for {`"${searchingKeyword} "`}  <CloseCircleOutlined onClick={handleCloseButton}/></Text>
              
            </div>
              ) : null
            }
            <div  className="filter_result">
              <Text>
                showing {products.length === 0 ? 0 : currentPage}-
                {products.length < postsPerPage
                  ? products.length
                  : postsPerPage}{" "}
                of {products.length} results
              </Text>
            </div>
          </div>
          {/* for showing cards data */}
          {isLoading ? (
            <div className="loader">
              <div>
                <Spin />
              </div>
            </div>
          ) : newData?.length ? (
            Object.keys(newData)?.map((item, index) => {
              const {
                Ingredient,
                productType,
                productCategory,
                dosageForm,
                packSize,
                tradeName,
                pic1,
              } = newData?.[item].productDetails;
              return (
                <div key={index} className="carrd">
                  <Card>
                    <div className="card_container">
                      <div>
                        <img
                          src={pic1}
                          alt="products image"
                          className="cards_img"
                        />
                      </div>
                      <Space direction="vertical" className="card_data">
                        {/* <img src="" alt="Logo" /> */}
                        {/* <Text>
                        <Link id={id} onClick={handleId}>
                          <strong className="card_link">{}</strong>
                        </Link>
                      </Text> */}
                        <Text type="secondary">
                          Product ID: <Text>{newData[item]._id}</Text>
                        </Text>

                        <Text type="secondary">
                          Ingredients:{" "}
                          <Text className="blue_text">{Ingredient}</Text>
                        </Text>

                        <Text type="secondary">
                          Product Type:
                          <Text className="blue_text">{productType}</Text>
                        </Text>

                        <Text type="secondary">
                          Product Category:
                          <Text className="blue_text">{productCategory}</Text>
                        </Text>

                        <Text type="secondary">
                          Dosage Form:{" "}
                          <Text className="blue_text">{dosageForm}</Text>
                        </Text>

                        <Text type="secondary">
                          Pack Size: <Text>{packSize}</Text>
                        </Text>

                        <Text type="secondary">
                          Trade Name: <Text>{tradeName}</Text>
                        </Text>
                        <Space className="buttons">
                          <Space>
                            <Button type="primary" id={newData[item]._id} onClick={handleId}>
                              View Details
                            </Button>
                            <Button className="send-rfi-button">
                              Send RFI
                            </Button>
                          </Space>
                        </Space>
                      </Space>
                    </div>
                  </Card>
                </div>
              );
            })
          ) : (
            <div className="empty_container">
              <div>
                <Empty description={false} className="empty_data">
                  No Product Found
                </Empty>
              </div>
            </div>
          )}
          <div className="pagination">
            {!!products.length && (
              <Space>
                <Pagination
                  loading={isLoading}
                  defaultCurrent={currentPage}
                  pageSize={postsPerPage}
                  total={products.length}
                  onChange={handlePage}
                />
              </Space>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default Searching;